<section class="login-frame">
  <div class="login-card">
    <ul>
      <li class="cabecera-login">
        <h3><span i18n="@@identification">Identificación</span></h3>
      </li>
      <li>
        <mat-form-field appearance="outline" class="full-width" focused cdkFocusInitial>
          <mat-label i18n>Usuario</mat-label>
          <mat-icon matIconPrefix>person</mat-icon>
          <input matInput placeholder="User" [value]="user()" (input)="user.set($any($event.target).value)">
          @if (!user()) {
            <mat-hint i18n>Introduzca nombre de usuario</mat-hint>
          }
        </mat-form-field>
      </li>

      <li class="last-line">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n>Clave</mat-label>
          <mat-icon matIconPrefix>lock</mat-icon>
          <input matInput [type]="hide() ? 'password' : 'text'" [value]="pwd()" (input)="pwd.set($any($event.target).value)">
          <button mat-icon-button matSuffix type="button" (click)="hide.set(!hide())">
            <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (!pwd()) {
            <mat-hint i18n>Introduzca su clave de acceso</mat-hint>
          }
        </mat-form-field>
      </li>

      <li class="btn-wrapper">
        <button mat-flat-button color="primary"
          [btnLoading]="loading()"
          [disabled]="formInvalid()" (click)="checkUser()">
          <span i18n>Acceder</span>
        </button>
        <!-- <code><pre>{{ user() }} - {{ pwd() }} - {{ loading() }}</pre></code> -->
      </li>

      <li class="btn-wrapper">
        <button mat-flat-button color="primary"
          [btnLoading]="loading()"
          (click)="registrarse()">
          <span i18n>Registrate!</span>
        </button>
        <!-- <code><pre>{{ user() }} - {{ pwd() }} - {{ loading() }}</pre></code> -->
      </li>
      
      
      <li>
        <p style="font-size: 80%; text-align: center;">
          <span i18n>¿Ha olvidado su clave? 
            <button mat-button type="button" (click)="openPasswordRecoveryWindow()">aquí</button>
          </span>
        </p>
      </li>
    </ul>
  </div>
</section>